import OrbitAvatar from '@/components/OrbitAvatar'
import { getOrganizationList } from '@/services/organization/organization.service'
import { selectUser } from '@/store/user/user.slice'
import { useRequest } from 'ahooks'
import { Avatar, Col, Divider, Row, Tabs, Typography } from 'antd'
import classnames from 'classnames'
import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Outlet, useMatch } from 'react-router-dom'
import styles from './index.module.css'
import { useHasPermissions } from '@/components/OPermission/OPermission'
const { TabPane } = Tabs
const { Text } = Typography

const tabItems = [
  { text: 'Projects', key: 'projects', permissions: [] },
  { text: 'Organizations', key: 'organizations', permissions: [] },
]

export default memo(function UserProfile() {
  const navigate = useNavigate()
  const match = useMatch('/home/:key')
  const activeKey = useMemo(() => match?.params.key! || '', [match])
  const userInfo = useSelector(selectUser).userInfo!
  const hasPermission = useHasPermissions()
  const tabOnChange = (activeKey: string) => {
    navigate(activeKey)
  }

  const authedTabs = tabItems.filter((tab) => {
    if (tab.permissions) {
      return hasPermission(tab.permissions)
    }
    return tab;
  })

  const sources = authedTabs.map(item => item.key)
  if (!sources.includes(activeKey) && activeKey) {
    navigate('404')
    return null
  }

  return (
    <div className={'py-3'}>
      <div className={classnames('container-xl px-3')}>
        <Row gutter={16}>
          <Col span={6}>
            <div className={styles.avatarContainer}>
              <OrbitAvatar avatar={userInfo?.avatar!} name={userInfo?.fullName} size={100} />
              <Text className={'mt-2'}>{userInfo.fullName}</Text>
            </div>
          </Col>
          <Col span={18}>
            <Tabs activeKey={activeKey} onChange={tabOnChange}>
              {authedTabs.map((item) => (
                <TabPane tab={item.text} key={item.key} />
              ))}
            </Tabs>
            <div className={styles.contentChildren}>
              <Outlet />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
})
